import {inject, Injectable} from '@angular/core';
import {AppStateService} from "../../core/state/app-state.service";

@Injectable({
  providedIn: 'root'
})
export class AnalysisTimingService {

  private appStateService = inject(AppStateService);

  markStarted(analysisId?: number) {
    if (!analysisId) return;

    const current = this.appStateService.analysisTiming();
    if (current?.analysisId !== analysisId) {
      this.appStateService.patch({analysisTiming: {analysisId, startTime: new Date().toISOString()}});
    }
  }

  markCompleted(analysisId?: number) {
    if (!analysisId) return;

    const current = this.appStateService.analysisTiming();
    if (current?.analysisId === analysisId && !current.completedTime) {
      this.appStateService.patch({analysisTiming: {...current, completedTime: new Date().toISOString()}});
    }
  }

  getTimings(analysisId?: number): { analysisDurationSeconds?: number, timeToUploadSeconds?: number } {
    const timing = this.appStateService.analysisTiming();
    if (!analysisId || timing?.analysisId !== analysisId || !timing.completedTime) {
      return {};
    }

    const startMs = new Date(timing.startTime).getTime();
    const completedMs = new Date(timing.completedTime).getTime();
    return {
      analysisDurationSeconds: Math.round((completedMs - startMs) / 1000),
      timeToUploadSeconds: Math.round((Date.now() - completedMs) / 1000)
    };
  }
}
